import { Box } from '@mui/material';

type Props = {
  maxCoount: number;
  questionIndex: number;
};

const QuestionProgress = ({ maxCoount, questionIndex }: Props) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
      {Array.from({ length: maxCoount }).map((_, index) => (
        <Box
          key={index}
          sx={{
            height: 4,
            flex: 1,
            borderRadius: 2,
            bgcolor: index < questionIndex + 1 ? 'primary.main' : 'grey.300'
          }}
        />
      ))}
    </Box>
  );
};

export default QuestionProgress;
